import { Component, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'unh-filter-project-grid',
  templateUrl: './filter-project-grid.component.html',
  styleUrls: ['./filter-project-grid.component.scss']
})
export class FilterProjectGridComponent {
  // Todo: Tipar
  @Input() projectFilters = [];

  @ContentChild('filterProjectItemTemplateRef', { static: false })
  filterProjectItemTemplateRef: TemplateRef<any>;

}
